import React, { useEffect, useState } from 'react';
import { Snackbar, Alert, Box, Typography } from '@mui/material';
import PaymentsIcon from '@mui/icons-material/Payments';

/**
 * Toast nhỏ góc màn hình nhắc user kiểm tra tổng kết lương.
 * Hiển thị từ ngày 5 đến ngày 8 hàng tháng (lương trả mùng 10).
 */
const PayrollReadyToast = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const day = new Date().getDate();
    if (day >= 5 && day <= 8) setOpen(true);
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={8000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert
        severity="info"
        variant="filled"
        icon={<PaymentsIcon />}
        onClose={() => setOpen(false)}
        sx={{
          maxWidth: 360,
          background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
          boxShadow: '0 8px 24px rgba(25,118,210,0.35)',
          alignItems: 'flex-start',
        }}
      >
        <Typography variant="body2" fontWeight={700} sx={{ mb: 0.25 }}>
          Đã có tổng kết lương
        </Typography>
        <Typography variant="caption" sx={{ display: 'block', opacity: 0.95 }}>
          Bạn vào mục "Lịch sử → Thu nhập theo kỳ" để kiểm tra trước ngày trả lương (mùng 10).
        </Typography>
      </Alert>
    </Snackbar>
  );
};

export default PayrollReadyToast;
